import React from 'react';
import { observer } from 'mobx-react';
import { Button, Form, Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';

/**
 * Modal for selecting the datatype of a molecular file during loading of local files
 */
const SelectDatatype = observer(
	class SelectDatatype extends React.Component {
		constructor(props) {
			super(props);
			this.handleCancel = this.handleCancel.bind(this);
			this.handleOkay = this.handleOkay.bind(this);
		}

		/**
		 * gets the select inputs for each file
		 * @return {FormGroup[]}
		 */
		getSelect() {
			return this.props.fileNames.map((fileName, i) => (
				<Form.Group key={fileName}>
					<Form.Label>{`${fileName} datatype`}</Form.Label>
					<Form.Select
						onChange={(e) => this.handleChange(fileName, e.target.value, i)}
						value={this.props.selectedTypes[i]}
					>
						<option value="CNVDisc">Discrete CNV data</option>
						<option value="CNVCont">Continuous CNV data</option>
						<option value="UnspecCont">Non-CNV continuous</option>
					</Form.Select>
				</Form.Group>
			));
		}

		/**
		 * handles selecting a different datatype
		 * @param {string} fileName
		 * @param {string} value - selected option
		 * @param {number} index - index of the file in fileName array
		 */
		handleChange(fileName, value, index) {
			switch (value) {
				case 'UnspecCont':
					this.props.setDatatype(index, value, 'CONTINUOUS', fileName);
					break;
				case 'CNVCont':
					this.props.setDatatype(index, value, 'CONTINUOUS', 'COPY_NUMBER_ALTERATION');
					break;
				default:
					this.props.setDatatype(index, value, 'DISCRETE', 'COPY_NUMBER_ALTERATION');
					break;
			}
		}

		handleOkay() {
			this.props.callback(true);
			this.props.closeModal();
		}

		handleCancel() {
			this.props.callback(false);
			this.props.closeModal();
		}

		render() {
			return (
				<Modal show={this.props.modalIsOpen} onHide={this.props.closeModal}>
					<Modal.Header closeButton>
						<Modal.Title>Select data types for provided files</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<form>{this.getSelect()}</form>
					</Modal.Body>
					<Modal.Footer>
						<Button onClick={this.handleCancel}>Cancel</Button>
						<Button onClick={this.handleOkay}>Okay</Button>
					</Modal.Footer>
				</Modal>
			);
		}
	}
);
SelectDatatype.propTypes = {
	closeModal: PropTypes.func.isRequired,
	modalIsOpen: PropTypes.bool.isRequired,
	callback: PropTypes.func.isRequired,
	setDatatype: PropTypes.func.isRequired,
	fileNames: PropTypes.arrayOf(PropTypes.string),
};
export default SelectDatatype;
